import React, { useEffect, useState, Fragment } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons'

import MieszkaniecDaneWodaRozliczenieZaliczki from "./MieszkaniecDaneWodaRozliczenieZaliczki.js";
import MieszkaniecDaneWodaRozliczenieStawki from "./MieszkaniecDaneWodaRozliczenieStawki.js";
import MieszkaniecDaneWodaRozliczenieKoszt from "./MieszkaniecDaneWodaRozliczenieKoszt.js";
import MieszkaniecDaneWodaRozliczeniePodsumowanie from "./MieszkaniecDaneWodaRozliczeniePodsumowanie.js";
import MieszkaniecDaneWodaRozliczenieLegenda from "./MieszkaniecDaneWodaRozliczenieLegenda.js";
import MieszkaniecDaneWodaRozliczenieWydrukModal from "./Wydruk/MieszkaniecDaneWodaRozliczenieWydrukModal.js";
import MieszkaniecDaneWodaRozliczenieStany from "./MieszkaniecDaneWodaRozliczenieStany.js";
import MieszkaniecDaneWodaRozliczenieMetraz from "./MieszkaniecDaneWodaRozliczenieMetraz.js";

const MieszkaniecDaneWodaRozliczenie = props => {
    
    const { grupaUdzial, wybranyOdczyt, mieszkaniec, adres, rozliczenieWody } = props;


    const [rozliczenieWodyAkt, setRozliczenieWodyAkt] = useState([]);
    const [procent, setProcent] = useState(undefined);
    const [odczyty, setOdczyty] = useState(undefined);

    useEffect( () => {
        const temp = rozliczenieWody?.
            find( r => new Date(r?.okresPoczatek) <= new Date(wybranyOdczyt?.okres_poczatek) 
                && new Date(r?.okresKoniec) >= new Date(wybranyOdczyt?.okres_koniec)
                /*&& r?.opublikowany == 1*/ )
        setRozliczenieWodyAkt(temp);
        setProcent(temp?.procenty?.find( p => p?.id_user == grupaUdzial?.id_user && p?.grupa_numer == grupaUdzial?.grupa_numer));
        setOdczyty(temp?.odczytyWZakresie?.find( p => p?.id_user == grupaUdzial?.id_user && p?.grupa_numer == grupaUdzial?.grupa_numer))
    },[rozliczenieWody, wybranyOdczyt]);

    const [showPrint, setShowPrint] = useState(false);

    const handleShowPrint = () => setShowPrint( prevState => !prevState);
    
    return (
        <div className="planpowaneZuzycie rozliczenie">
            <div className="naglowek">
                <h5>
                    Rozliczenia (zamknięte okresy)
                </h5>
            </div>
            {
                rozliczenieWodyAkt && (
                    <div className="dane ramka-inset-shadow">
                        <div className="naglowek">
                            <p style={{fontWeight: "600", width: "100%", textAlign: "center", margin: "5px 0"}}>
                                {rozliczenieWodyAkt.opis}    
                            </p>
                            <FontAwesomeIcon 
                                icon={faPrint} 
                                className='pointer'
                                onClick={handleShowPrint}
                            />                        
                        </div>
                        <div className="tabele">
                            <MieszkaniecDaneWodaRozliczenieStany
                                procent={procent}
                                odczyty={odczyty}
                            />
                        </div>
                        <div className="tabele">
                            <MieszkaniecDaneWodaRozliczenieZaliczki
                                rozliczenieWodyAkt={rozliczenieWodyAkt}
                                procent={procent}
                            />
                            <MieszkaniecDaneWodaRozliczenieStawki
                                rozliczenieWodyAkt={rozliczenieWodyAkt}
                            />        
                        </div>
                        {
                            wybranyOdczyt ? (
                                <Fragment>
                                    <MieszkaniecDaneWodaRozliczenieMetraz
                                        procent={procent}
                                    />
                                    <MieszkaniecDaneWodaRozliczenieKoszt
                                        procent={procent}
                                        odczyty={odczyty}
                                        rozliczenieWodyAkt={rozliczenieWodyAkt}
                                    />
                                    <MieszkaniecDaneWodaRozliczeniePodsumowanie
                                        procent={procent}
                                    />
                                    <MieszkaniecDaneWodaRozliczenieLegenda
                                        rozliczenieWodyAkt={rozliczenieWodyAkt}
                                    />
                                </Fragment>

                            ) : ""
                        }
                        {
                            showPrint && (
                                <MieszkaniecDaneWodaRozliczenieWydrukModal
                                    setShowPrint={setShowPrint}
                                    rozliczenieWodyAkt={rozliczenieWodyAkt}
                                    procent={procent}
                                    odczyty={odczyty}
                                    mieszkaniec={mieszkaniec}
                                    adres={adres}
                                />
                            )
                        }

                    </div>
                )
            }   
        </div>
    )
}

export default MieszkaniecDaneWodaRozliczenie;